import { useEffect, useState } from 'react'
import { IUser } from '../../../types/users'
import { ROLES } from '../../../config/user'
import UserAppBar from '../UserPanel/UserAppBar'
import { getUser } from '../../../services/user'
import { IService } from '../../../types/services'
import ShareDocumentItem from './ShareDocumentItem'
import { makeStyles } from '@material-ui/core/styles'
import { useSession } from '../../../context/SessionContext'
import { getServicesShare } from '../../../services/services'
import BussinessAppBar from '../BussinessPanel/BussinessAppBar'
import SuperUserAppBar from '../SuperUserPanel/SuperUserAppBar'
import { Container, Grid, Typography } from '@material-ui/core'
import Alert, { ActionsOptType } from '../../../components/Alert'

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addTemplate: {
    maxWidth: '60vw',
    marginBottom: '2vh',
  },
}))

/**
 * Custom `ShareDocuemntsList` component declaration. * 
 * This component is to Load appBar and show the list of enabled templates for the user.
 * @return ShareDocuemntsList
*/
const ShareDocuemntsList = (): JSX.Element => {
  const classes = useStyles()
  const { user } = useSession()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })
  const [userObj, setUserObj] = useState<IUser>()
  const [services, setServices] = useState<IService[] | null>()

  // Load user data
  useEffect(() => {
    const loadUser = async () => {
      try {
        const _user = await getUser()
        if (_user) setUserObj(_user.data)
      } catch (error) {
        return error;
      }
    }
    loadUser()
  }, [])

  // Load templates shared with the user
  useEffect(() => {
    const fetchData = async () => {
      if(userObj)
      {
        const { data, error } = await getServicesShare(userObj.email)
        if (data) setServices(data)
        if (error) setAlertOptions({ message: error, open: true, type: 'error' })
      }
    }
    if (!services) {
      fetchData()
    }
  }, [userObj])

  return (
    <>    
      {user?.role === ROLES.SUPER_USER && (
        <SuperUserAppBar/>
      )}
      {user?.role === ROLES.BUSSINESS && (
        <BussinessAppBar/>
      )}
      {user?.role === ROLES.USER && (
        <UserAppBar/>
      )} 
      <Container className={classes.cardGrid} maxWidth="md">
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <Typography
        component="p"
        variant="body1"
        align="center"
        color="textPrimary"
        gutterBottom
        style={{ fontSize: '2rem', fontWeight: 'bold' }}
      >
        Lista de documentos compartidos
      </Typography>
      <Typography 
        variant="h6"
        align="center"
        color="textSecondary"
        paragraph
        style={{ marginBottom: '35px' }}
      >
        Aquí podrás editar los documentos que hayan sido compartidos contigo por personas quienes necesitan tu colaboración para culminar la elaboración del documento
      </Typography>
    
      <Grid container justifyContent="center" spacing={4}>
        {services ? (
          services.map((service: IService, index: number) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <ShareDocumentItem service={service} />
            </Grid>
          ))
        ) : (
          <></>
        )}
      </Grid>
      </Container>
    </>
  )
}

export default ShareDocuemntsList